import { useState } from 'react'
import { useMutation } from 'urql'
import { gql } from '../gql/gql'
import { Button } from './ui/button'
import { Label } from './ui/label'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select'
import { SUPPORTED_CURRENCIES } from '../lib/currencies'

const UPDATE_USER_MUTATION = gql(`
  mutation UpdateCurrency($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      preferredCurrency
    }
  }
`)

interface CurrencyPickerDialogProps {
  currentCurrency?: string | null
  name: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function CurrencyPickerDialog({ currentCurrency, name, open, onOpenChange }: CurrencyPickerDialogProps) {
  const [currency, setCurrency] = useState(currentCurrency || 'USD')
  const [{ fetching }, updateUser] = useMutation(UPDATE_USER_MUTATION)

  const handleSave = async () => {
    await updateUser({ input: { name, preferredCurrency: currency } })
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-xs">
        <DialogHeader>
          <DialogTitle>Currency</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 pt-1">
          <div className="space-y-1">
            <Label htmlFor="currency-picker">Currency</Label>
            <Select value={currency} onValueChange={setCurrency}>
              <SelectTrigger id="currency-picker">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                {SUPPORTED_CURRENCIES.map(({ code, label }) => (
                  <SelectItem key={code} value={code}>{label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <Button className="w-full" onClick={handleSave} disabled={fetching}>
            {fetching ? 'Saving...' : 'Save'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
